import { AloftPriceJSON } from '@aloft/toolkit-shared';
import { createAction } from '@reduxjs/toolkit';

export const setOpinionOfSiteValue = createAction<AloftPriceJSON>(
  'propertyData/setOpinionOfSiteValue',
);
